import script from "./account.vue?vue&type=script&setup=true&lang=js"
export * from "./account.vue?vue&type=script&setup=true&lang=js"

import "./account.vue?vue&type=style&index=0&id=de2d0bde&scoped=true&lang=css"

import exportComponent from "D:\\work\\hongy-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de2d0bde"]])

export default __exports__